import RequestManager from "../../API";
import api from "../../utils/api";
import { storeLabels } from "./labelsActions";
import { LabelsMdl } from "../../Modal/Labels";
import { setLoading } from "../common/commonActions";

export const getLabels =
  (query?: string,setIsLoading?:any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.GET_LABELS,
      '',
      query
    );
    if (response) {
      const labelsData: LabelsMdl[] = response.value;
      dispatch(storeLabels(labelsData));
    } else {
      dispatch(storeLabels([]));
    }
    dispatch(setLoading(false));
    setIsLoading(false)
  };
